S.form =
  {
      elements: {
          $mark: null,
          $required: null,
          $radioButton: null,
          $telefon: null,
          $message: null,
          $privacyKontakt: null,
          $privacyNewsletter: null,
      },
      init()
      {
          this.addLink();

          this.elements.$mark.find('.m-mark').remove();

          if (this.elements.$message.hasClass('is-ina')) {
              this.checkRadioButton();
          }

          this.$module.on('submit', (event) =>
          {
              sessionStorage.setItem('scrollToFooter', '1');
          });
      },

      checkRadioButton()
      {
          this.elements.$radioButton.find('#contact_typeform_newsletter').attr('checked', 'checked');

          this.elements.$privacyNewsletter.show();
          this.elements.$privacyKontakt.hide();
          this.elements.$message.removeClass('js-required');
          this.elements.$telefon.hide();
          this.elements.$message.hide();

          this.elements.$radioButton.on('click', (e) =>
          {
              if (e.target.type === 'radio')
              {
                  if (e.target.value === 'newsletter')
                  {
                      this.elements.$privacyNewsletter.show();
                      this.elements.$privacyKontakt.hide();
                      this.elements.$message.removeClass('js-required');
                      this.elements.$telefon.hide();
                      this.elements.$message.hide();
                  }
                  else
                  {
                      this.elements.$privacyNewsletter.hide();
                      this.elements.$privacyKontakt.show();
                      this.elements.$telefon.show();
                      this.elements.$message.show();
                  }
              }
          });
      },

      addLink()
      {
          const msg = this.elements.$privacyNewsletter.eq(1).children().eq(1).text();

          if (msg.indexOf('Datenschutz') !== -1)
          {
              const subBefore = msg.substring(0, msg.indexOf('Datenschutz'));
              const subAfter = msg.substring(msg.indexOf('Datenschutz') + 11, msg.lenght);

              this.elements.$privacyNewsletter.eq(1).children().eq(1).html('<span>' + subBefore + '<a href="https://www.nachhaltige-agrarlieferketten.org/datenschutz/" target="_blank">Datenschutz</a>' + subAfter + '</span>');
          }

          if (msg.indexOf('data protection') !== -1)
          {
              const subBefore = msg.substring(0, msg.indexOf('data protection'));
              const subAfter = msg.substring(msg.indexOf('data protection') + 15, msg.lenght);

              this.elements.$privacyNewsletter.eq(1).children().eq(1).html('<span>' + subBefore + '<a href="https://www.nachhaltige-agrarlieferketten.org/en/data-protection/"  target="_blank">data protection</a>' + subAfter + '</span>');
          }
      },
  };
